import { Slot } from 'radix-ui'
import type { ButtonHTMLAttributes } from 'react'
import { cn } from '../cn.ts'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger'
export type ButtonSize = 32 | 36 | 40

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-pop text-white hover:shadow-pop',
  secondary: 'bg-card text-text-1 border border-line-2 hover:border-line-3',
  ghost: 'bg-transparent text-text-1 hover:bg-grey-2',
  danger: 'bg-card text-apricot-fg border border-line-2 hover:border-apricot hover:bg-apricot-bg',
}
const sizes: Record<ButtonSize, string> = {
  32: 'h-8 px-3.5 text-[13px] gap-1.5',
  36: 'h-9 px-4 text-sm gap-2',
  40: 'h-10 px-5 text-[15px] gap-2',
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  asChild?: boolean
}

export function Button({ variant = 'secondary', size = 36, asChild, className, type, ...rest }: ButtonProps) {
  const Comp = asChild ? Slot.Root : 'button'
  return (
    <Comp
      type={asChild ? undefined : (type ?? 'button')}
      className={cn(
        'inline-flex select-none items-center justify-center whitespace-nowrap rounded-pill font-medium',
        'transition-[color,background-color,border-color,box-shadow] duration-150 ease-out',
        'disabled:pointer-events-none disabled:opacity-50',
        variants[variant],
        sizes[size],
        className,
      )}
      {...rest}
    />
  )
}
